export default {

  degree: [],

  collaborationType: [],

  companyField: [],

  socialNetwork: [],

  jobAdvertisement: [],
  jobAdvertisementById: {},

  jobRequest: [],
  jobRequestById: {},
};
